import { render, staticRenderFns } from "./Cadouri.vue?vue&type=template&id=91a38ae8&scoped=true&"
import script from "./Cadouri.ts?vue&type=script&lang=ts&"
export * from "./Cadouri.ts?vue&type=script&lang=ts&"
import style0 from "./Cadouri.vue?vue&type=style&index=0&id=91a38ae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a38ae8",
  null
  
)

export default component.exports